import { render, staticRenderFns } from "./IngestorEdit.vue?vue&type=template&id=b4539282"
import script from "./IngestorEdit.vue?vue&type=script&lang=js"
export * from "./IngestorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports